export const LAST_VIEW_CHANGED_WEB_VITALS = 'LAST_VIEW_CHANGED_WEB_VITALS';
